import React from 'react';
import { Phone, ShieldCheck } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';
import { track } from '@/lib/analytics';

const UtilityBar = ({ phoneDisplay = '(936) 828-2500', phoneTel = '9368282500' }) => {
  const { lang, switchLang, t } = useLanguage();

  const handleCall = () => track('phone_click', { location: 'utility_bar' });

  return (
    <div className="util-bar" data-testid="utility-bar">
      <div className="util-bar__inner">
        <div className="util-bar__left">
          <span>{t('utility.help247')}</span>
          <a href={`tel:${phoneTel}`} className="util-bar__phone" onClick={handleCall} data-testid="utility-call-link">
            <Phone size={14} /> {phoneDisplay}
          </a>
          <span className="util-bar__trust"><ShieldCheck size={13} style={{ verticalAlign: 'text-bottom', marginRight: 4 }} />{t('utility.trust')}</span>
        </div>
        <div className="util-bar__right">
          <div className="lang-toggle" role="group" aria-label="Language selector" data-testid="language-toggle">
            <button type="button" className={lang === 'en' ? 'active' : ''} onClick={() => switchLang('en')} data-testid="lang-en-btn" aria-pressed={lang === 'en'}>EN</button>
            <button type="button" className={lang === 'es' ? 'active' : ''} onClick={() => switchLang('es')} data-testid="lang-es-btn" aria-pressed={lang === 'es'}>ES</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UtilityBar;
